<!--
 * @Author: zhwenlong 2546258285@qq.com
 * @Date: 2022-08-15 15:06:46
 * @LastEditors: zhwenlong 2546258285@qq.com
 * @LastEditTime: 2022-09-23 21:27:38
 * @FilePath: \fore\src\publicElement\zg-compoundSelect\index.vue
 * @Description: 复合选择框， 多选多种类型选择 详细使用参考elment-ui select和Cascader联动选择器
 *
 * Copyright (c) 2022 by zhwenlong 2546258285@qq.com, All Rights Reserved.
-->
<template>
  <div class="compoundSelect">
    <div class="typeBox">
      <!-- 选择器 -->

      <el-select
        v-if="name !== 'datePicker'"
        v-model="typeValue"
        @change="onTypeChange"
        placeholder="请选择"
      >
        <slot v-if="$slots.typeOpions" name="typeOpions"></slot>
        <el-option
          v-else
          v-for="item in typeOpions"
          :key="item.label"
          :label="item.label"
          :value="item.value"
        >
          <span>{{ item.label }}</span>
          <span>{{ item.text }}</span>
        </el-option>
      </el-select>
      <el-select
        v-if="name == 'datePicker'"
        v-model="dateValue"
        @change="onTypeChanges"
        placeholder="请选择"
      >
        <slot v-if="$slots.typeOpions" name="typeOpions"></slot>
        <el-option
          v-else
          v-for="item in typeOpions"
          :key="item.label"
          :label="item.label"
          :value="item.value"
        >
          <span>{{ item.label }}</span>
          <span>{{ item.text }}</span>
        </el-option>
      </el-select>
    </div>
    <div class="contentBox">
      <!-- 选择器 -->
      <el-select
        v-if="name == 'select'"
        :id="idRound + name"
        v-bind="configAttributes"
        v-on="setEventFn"
        v-model="cvalue"
        placeholder="请选择"
      >
        <slot v-if="$slots.valueOpions" name="valueOpions"></slot>
        <el-option
          v-else
          v-for="item in valueOpions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <!-- 级联选择器 -->
      <el-cascader
        v-if="name == 'cascader'"
        :id="idRound + name"
        :options="valueOpions"
        v-on="setEventFn"
        v-bind="configAttributes"
        v-model="cvalue"
        clearable
        placeholder="请选择"
      >
      </el-cascader>

      <!-- 级联选择器 -->
      <el-date-picker
        v-if="name == 'datePicker'"
        :value-format="format"
        v-on="setEventFn"
        :key="runTimer"
        @change="valueChange"
        placeholder="请选择"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        v-bind="configAttributes"
        v-model="cvalue"
        :type="type"
      >
      </el-date-picker>
    </div>
    <!-- <input type="text"> -->
    <div style="display: none">{{ setValue }}</div>
  </div>
</template>

<script>
/**
 * @description: 复合选择器， 具有类型的二级选择
 * * 可以根据element-ui 添加参数， 目前只添加常用属性
 * ------     添加的属性严格介绍用途和使用方式     ------------
 *
 * =
 *
 * --- 类型和内容插槽 ---
 * 对应slot name值 类型typeOpions  内容valueOpions
 *
 *
 * @return {*}
 */
export default {
  name: "compoundSelect",
  props: {
    //强制正序,即 gt 输出在start上 lt输出在end上
    forcePositive: { type: Boolean, default: false },
    //    -------------element-ui 组件 分类type------------------
    name: {
      type: String,
      default: "select", //type =>  select , cascader, datePicker//需要什么自己去添加
    },

    /**
     * @description: 根据name匹配element 可设置的属性值
     * @return {*}
     */
    configAttributes: {
      type: Object,
      default: () => {},
    },
    // 时间选择器 -- 时间格式
    format: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss",
    },
    /**
     * @description: 根据name匹配element 可设置的回调函数
     * @return {*}
     */
    configEvents: {
      type: Object,
      default: () => {},
    },

    //  -----------数据类型--------------
    /**
     * 添加一个name属性 针对选择是日期的时候， 针对el-date-picker中的type属性
     *  type => year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange
     */
    typeOpions: {
      type: Array,
      default: () => [
        { label: "=", value: true, text: "等于" },
        { label: "⊆", value: false, text: "包含" },
      ],
    },

    //  -----------数据选择内容--------------
    valueOpions: {
      type: Array,
      default: () => [],
    },

    //  数据传值回显 现阶段不能使用v-model 好像只能在input中使用， 其他的不起作用
    values: {
      type: Array,
      default: () => [],
    },
    defaultDateType: {
      type: String,
      default: () => "monthrange",
    },
  },

  mounted() {
    this.type = this.defaultDateType;
  },

  model: {
    prop: "value",
    event: "newValue",
  },
  computed: {
    setValue: {
      get() {
        let values = this.values;
        this.typeValue = values.length > 0 ? values[0] : "";
        this.cvalue = values.length > 1 ? values[1] : "";
        return values;
      },
      set(value) {
        this.$emit("update:values", value);
      },
    },
    setEventFn() {
      let config = {};
      for (let i in this.configEvents) {
        let value = this.configEvents[i] ? this.configEvents[i] : i;
        config[i] = this.setEvent;
      }
      return config;
    },
  },
  watch: {
    typeValue: function () {
      console.log(this.typeValue);
      this.setValue = [this.typeValue, this.cvalue];
    },
    cvalue: function () {
      this.setValue = [this.typeValue, this.cvalue];
    },
    dateValue(val) {
      this.type = this.typeOpions.find((i) => i.value === val).type;
    },
  },

  data() {
    return {
      typeValue: "2222",
      cvalue: [],
      dateValue: "range",
      idRound: null,
      type: "monthrange",
      runTimer: null,
      value: {},
    };
  },
  methods: {
    onTypeChange(ev) {
      //    ----------------争对datePickert的type选择做特殊处理----------------
      if (this.name == "datePicker") {
        //      根据type的类型改变datepicker 的type类型
        let params = this.typeOpions.find((q) => q.value == ev) || {};
        this.type = params.type || "date";
        this.cvalue = "";

        // 改变了type 让时间组件重新渲染， 避免date交互错乱
        this.runTimer = new Date().getTime();
      }

      //       this.$emit("change", [ev, this.cvalue]);
    },
    onTypeChanges(e) {
      this.cvalue = undefined;
    },
    /**
     * @description: 设置事件中的行为方式 目前支持change
     * @return {*}
     */
    setEvent(ev) {
      this.$emit("change", [this.typeValue, ev]);
    },
    valueChange(e) {
      let range = { symbol: this.dateValue };
      if (this.dateValue === "range") {
        if (e && e.length > 0) {
          range.start = e[0];
          range.end = e[1];
          this.$emit(
            "change",
            { start: e[0], end: e[1], symbol: this.dateValue },
            true
          );
        } else {
          this.$emit("change", {}, false);
        }
      } else {
        if (e) {
          let data = {
            start: this.dateValue === "lt" ? e : undefined,
            end: this.dateValue === "gt" ? e : undefined,
            symbol: this.dateValue,
          };
          if (this.forcePositive) {
            data = {
              start: this.dateValue === "gt" ? e : undefined,
              end: this.dateValue === "lt" ? e : undefined,
              symbol: this.dateValue,
            };
          }
          range.start = data.start;
          range.end = data.end;

          this.$emit("change", data, true);
        } else {
          this.$emit("change", {}, false);
        }
      }

      this.value = range;
      this.$emit("newValue", range);
    },
  },
};
</script>

<style lang="less" scoped>
.compoundSelect {
  display: flex;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  height: 28px;
  line-height: 28px !important;

  .typeBox {
    width: 34px;
    background: #fcfcfc;
    border-right: 1px solid #eeeeee;

    /deep/ .el-select {
      height: 100%;
      line-height: 100%;

      .el-input__suffix {
        display: none;
      }

      .el-input__inner {
        border-radius: 0;
        border: none;
        height: 100%;
        padding: 0;
        text-align: center;
        line-height: 100%;
        color: #333;
        background: transparent;
      }
    }
  }

  .contentBox {
    flex: 1;

    /deep/ .el-select,
    /deep/ .el-cascader {
      height: 100%;

      .el-input__suffix {
        .el-icon-arrow-down,
        .el-icon-arrow-up {
          display: none;
        }
      }

      .el-input__inner {
        border-radius: 0;
        border: none;
        height: 28px !important;
        line-height: 28px !important;
        padding: 0 10px;
        color: #333;
      }
    }

    /deep/ .el-select {
      line-height: 100%;
    }

    /deep/ .el-date-editor {
      width: 220px;
      border: none;
      border-radius: 0;

      .el-icon-date,
      .el-range-separator {
        height: 28px !important;
        line-height: 28px !important;
      }

      .el-input__inner {
        padding: 0 30px !important;
      }
    }

    /deep/ .el-input__suffix {
      display: flex;
      align-items: center;
    }

    /deep/ .el-input__inner {
      border-radius: 0;
      border: none;
      height: 28px !important;
      line-height: 28px !important;
      padding: 0 10px;
      color: #333;
    }
  }
}

/deep/ .el-select__tags {
  // transform: translateY(-75%);
}
</style>
